import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bankActions } from "../redux/actions/bankActions";
import SelectField from "./Forms/SelectField";

const BanksSelect = ({
  className,
  onChange,
  disabled,
  label,
  variant,
  value
}) => {
  const [options, setOptions] = useState([]);

  const dispatch = useDispatch();
  const {
    items,
    tableConfig: {
      isLoading,
      page,
      limit,
      sort,
      filter
    }
  } = useSelector(state => state.banks);

  const load = useCallback(
    () => {
      const tConfig = {
        limit,
        page,
        sort,
        filter
      }
      return dispatch(bankActions.loadRequested(tConfig))
    },
    [dispatch, limit, page, sort, filter],
  )

  const handleScrollToBottom = () => {
    const newPage = page + 1;
    if ((newPage * limit) < items) {

      const tConfig = {
        limit,
        newPage,
        sort,
        filter
      }
      return dispatch(bankActions.loadRequested(tConfig))
    }
  }

  const generateOpts = banks => {
    return banks.map((el, i) => (
      {
        value: el.abbr,
        label: `${el.name} | ${el.abbr}`
      }
    ))
  }

  useEffect(() => {
    load();
  }, [load])

  useEffect(() => {
    if (items) {
      setOptions(generateOpts(items))
    }
  }, [items])

  return (
    <div>
      <SelectField
        label={label || "Bank"}
        options={options}
        className={className}
        value={value}
        onChange={onChange}
        variant={variant}
        componentProps={{
          isLoading: isLoading,
          onMenuScrollToBottom: handleScrollToBottom,
          isDisabled: disabled ? disabled : isLoading
        }}
        isClearable
      />
    </div>
  )
}

export default BanksSelect
